import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import {
  ConfigurationService,
  SemantriaConfiguration,
} from 'app/providers/semantria-api/configuration.service';
import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable()
export class ConfigurationVersionTrackerService {
  private configurationEmitter$ = new Subject<SemantriaConfiguration>();
  onConfigurationChange = this.configurationEmitter$.asObservable();

  constructor(private configService: ConfigurationService) {}

  reloadConfiguration(configId) {
    this.configService.getConfiguration(configId).then((res) => this.setConfiguration(res));
  }

  setConfiguration(configuration: SemantriaConfiguration) {
    this.configurationEmitter$.next(configuration);
  }
}
